import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import GroupLink from '../framework/group_link';

const ArticlesListItem = ({
	article_id,
	className,
	group,
	image_header,
	page,
	published_at,
	title,
}) => {
	return (
		<div className={`article-list-item me-2 mb-3 ${className}`}>
			<div className="">
				<div className="">
					<GroupLink
						aria-label={title}
						article_id={article_id}
						className="text-decoration-none"
						groups={[group.groups]}
						page={page}
					>
						{image_header && (
							<GatsbyImage
								alt={title}
								className="img-fluid article-list-item-img"
								draggable="false"
								image={getImage(image_header)}
							/>
						)}
						{!image_header && (
							<div className="article-list-item-img bg-primary-gradient-light"></div>
						)}
					</GroupLink>
				</div>
				<div className="mt-2 position-relative">
					{group?.groups && group?.title && (
						<GroupLink
							article_id={article_id}
							className="text-decoration-none text-break white-space-break text-dark"
							groups={[group.groups]}
							page={page}
						>
							<p className="xxs fw-800 mb-0 text-primary text-uppercase">
								{group.title}
							</p>
						</GroupLink>
					)}
					<h3 className="card-title article-list-item-title">
						<GroupLink
							article_id={article_id}
							className="text-decoration-none text-break white-space-break text-dark"
							groups={[group.groups]}
							page={page}
						>
							{title}
						</GroupLink>
					</h3>
					<p className="xs text-muted">{published_at}</p>
				</div>
			</div>
		</div>
	);
};

ArticlesListItem.propTypes = {
	article_id: PropTypes.number,
	className: PropTypes.string,
	excerpt: PropTypes.string,
	group: PropTypes.object,
	image_header: PropTypes.object,
	page: PropTypes.string,
	published_at: PropTypes.string,
	slug: PropTypes.string,
	title: PropTypes.string,
};

export default ArticlesListItem;
